import React from "react";
import { useNavigate } from "react-router-dom";
import { openSupportChat } from "../utils/openSupportChat";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="relative z-10 bg-card border-t border-border mt-8">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo and Description */}
          <div className="lg:col-span-1">
            <img
              src="/logo.png"
              alt="Cluck Casino"
              className="h-12 w-auto object-contain mb-4 cursor-pointer"
              onClick={() => navigate("/")}
            />
            <p className="text-sm text-muted-foreground mb-4">
              Participation in games is subject to eligibility requirements and
              may be restricted in certain jurisdictions. Please review our
              Terms and Conditions and Sweeps Rules for full details.
            </p>
          </div>

          {/* VIP & Social */}
          <div>
            <h3 className="text-white font-semibold mb-4">VIP & Social</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => navigate("/vip")}
                  className="text-muted-foreground hover:text-white transition-colors text-sm cursor-pointer"
                >
                  VIP
                </button>
              </li>
              <li>
                <a
                  href="https://x.com/Cluck_US"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Follow on X
                </a>
              </li>

              <li>
                <button
                  onClick={() => navigate("/blog")}
                  className="text-muted-foreground hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Guides
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={openSupportChat}
                  className="text-muted-foreground hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Help Center
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/offers")}
                  className="text-muted-foreground hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Quick Buy
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/affiliate")}
                  className="text-muted-foreground hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Affiliates
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => navigate("/terms")}
                  className="text-muted-foreground hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Terms of Service
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/privacy")}
                  className="text-muted-foreground hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Privacy And Cookie Policy
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/responsible-gaming")}
                  className="text-muted-foreground hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Responsible Gaming
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate("/amoe")}
                  className="text-muted-foreground hover:text-white transition-colors text-sm cursor-pointer"
                >
                  AMOE
                </button>
              </li>
            </ul>
          </div>

          {/* Need Help */}
          <div>
            <h3 className="text-white font-semibold mb-4">Need Help?</h3>
            <p className="text-sm text-muted-foreground mb-4">
              Cluck.Us is dedicated to providing you with the highest quality
              service and incredibly fun games.
            </p>
            <p className="text-sm text-muted-foreground mb-6">
              You can contact us 24/7 and find answers to your questions.
            </p>

            <div className="mb-6">
              <p className="text-sm text-muted-foreground mb-4">
                Cluck Bucks are free sweepstakes entries. They cannot be bought
                on their own, and are awarded on the day one welcome wheel, with
                Gold Coin purchases, and by free postal entry. Cluck Bucks must
                be used in gameplay before they become eligible for redemption.
                18+. No purchase necessary to participate. Play responsibly.
              </p>
              <p className="text-sm text-muted-foreground">
                <button
                  onClick={() => navigate("/amoe")}
                  className="text-orange-400 hover:text-orange-300 underline hover:cursor-pointer"
                >
                  Click
                </button>{" "}
                here for instructions on alternative method of entry.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="border-t border-border bg-card">
        <div className="container mx-auto px-4 py-4">
          <p className="text-xs text-muted-foreground text-center">
            Copyright © https://cluck.us is owned and operated by THE ROOST
            LIMITED incorporated and registered office is at 1 Nikis 1,
            Anthoupoli, Nicosia, Cyprus, P.C. 2350
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
